module.exports = __webpack_public_path__ + "img/img36.88450a53.png";